import React from "react";
import { Brain, Compass, ScanLine, Sparkles, GraduationCap, FlaskConical } from "lucide-react";
import { useSiteContent } from "@/lib/siteContent";

const ICONS = [
  <Brain className="w-6 h-6" key="i0" />,
  <ScanLine className="w-6 h-6" key="i1" />,
  <Compass className="w-6 h-6" key="i2" />,
  <Sparkles className="w-6 h-6" key="i3" />,
  <GraduationCap className="w-6 h-6" key="i4" />,
  <FlaskConical className="w-6 h-6" key="i5" />,
];

export const About = () => {
  const { content } = useSiteContent();
  const items = content.about_features || [];
  return (
    <section
      id="about"
      className="relative bg-[#0A2342] text-[#FDFBF7] py-24 lg:py-32 overflow-hidden"
    >
      <div
        className="absolute inset-0 opacity-[0.06]"
        style={{
          backgroundImage:
            "radial-gradient(circle at 1px 1px, #FDFBF7 1px, transparent 0)",
          backgroundSize: "32px 32px",
        }}
      />
      <div className="relative max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <div className="text-[11px] uppercase tracking-[0.3em] text-[#CBA358] font-semibold">
              {content.about_eyebrow}
            </div>
            <h2 className="font-display text-4xl lg:text-5xl mt-4 leading-[1.05] text-balance">
              {content.about_headline}
            </h2>
            <p className="mt-6 text-[#E5DFD3] leading-relaxed max-w-md">
              {content.about_description}
            </p>
          </div>

          <div className="lg:col-span-7 grid sm:grid-cols-2 gap-4">
            {items.map((it, idx) => (
              <BentoCard
                key={idx}
                icon={ICONS[idx % ICONS.length]}
                title={it.title}
                body={it.body}
                accent={idx === 0}
                span={idx === 0 || idx === items.length - 1 ? "sm:col-span-2" : ""}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

const BentoCard = ({ icon, title, body, accent = false, span = "" }) => (
  <div
    className={`relative p-7 border ${
      accent
        ? "border-[#CBA358] bg-[#CBA358]/[0.08]"
        : "border-[#FDFBF7]/15 bg-white/[0.03]"
    } hover:bg-white/[0.06] transition-colors ${span}`}
  >
    <div
      className={`w-11 h-11 flex items-center justify-center mb-5 ${
        accent ? "bg-[#CBA358] text-[#0A2342]" : "bg-white/10 text-[#CBA358]"
      }`}
    >
      {icon}
    </div>
    <h3 className="font-display text-xl text-white">{title}</h3>
    <p className="mt-2 text-[#E5DFD3]/85 text-sm leading-relaxed">{body}</p>
  </div>
);

export default About;
